'use client';

import { c as _c } from "react/compiler-runtime";
import { toastSettings } from "@/constants/project-specific/theme/toast";
import { ToastProvider } from "@heroui/react";
import { useIsMobile } from "hooks/utility/useIsMobile";
export default function Toast() {
  const $ = _c(4);
  const isMobile = useIsMobile();
  const t0 = isMobile ? toastSettings.mobileOffset || 20 : 0;
  const t1 = isMobile ? "top-center" : `${toastSettings.placement || "bottom-right"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      radius: `${toastSettings.radius || "md"}`,
      color: `${toastSettings.color || "default"}`,
      variant: `${toastSettings.variant || "flat"}`,
      timeout: toastSettings.timeout || 1000,
      hideIcon: toastSettings.hideIcon ? true : false,
      classNames: toastSettings.classNames
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t0 || $[2] !== t1) {
    t3 = <ToastProvider toastOffset={t0} placement={t1} toastProps={t2} />;
    $[1] = t0;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}